import { Map1 } from 'iconsax-react';
import { Button } from '@heroui/react';

export const PharmacySelect = ({ onPress }: { onPress?: () => void }) => {
  return (
    <div className="pb-4 pt-3">
      <div className="w-full border border-dashed border-[#EAEAEB] h-fit bg-[#F8F9FA] rounded-3xl flex flex-col items-center py-6">
        <Map1 size="24" color="#9CA5AC" />

        <p className="mt-4 text-[#9CA5AC] text-sm">Выберите пункт самовывоза</p>

        <Button
          color="primary"
          variant="bordered"
          className="mt-6"
          onPress={onPress}
        >
          Выбрать аптеку
        </Button>
      </div>
    </div>
  );
};
